import { createContext, useContext } from 'react';
import { IModalResolver } from './resolver.interface';

const ctx = createContext<IModalResolver>({
  resolve: () => Promise.reject(new Error('Modal provider not instantiated.')),
  resolveComponent: (name) => Promise.reject(new Error(`Can not resolve modal ${name}. Resolver not provided`)),
});
ctx.displayName = 'ModalResolver';

export const useModalResolver = () => {
  return useContext(ctx);
};

export const ModalResolverProvider = ctx.Provider;
